import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

const ListItem = ({ content }) => {
  return (
    <div>{!isEmpty(content) ? content : <span className="item__empty-cell">Not Set</span>}</div>
  )
}

ListItem.propTypes = {
  content: PropTypes.node,
}

export default ListItem
